// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: a short haptic tap. Android has navigator.vibrate; iOS Safari has no
// vibration API but plays the system haptic when a switch-style checkbox is
// toggled, so we flip a hidden one. Silent where neither exists. The native
// iOS/Android shell uses the platform's real haptic engine.

import {NativePlugins} from '@app/features/platform/native_mobile/NativeMobileBridge';

export function hapticTap(durationMs = 10): void {
	const nativeHaptics = NativePlugins.haptics();
	if (nativeHaptics) {
		void nativeHaptics.impact({style: durationMs >= 20 ? 'MEDIUM' : 'LIGHT'}).catch(() => undefined);
		return;
	}
	if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
		try {
			if (navigator.vibrate(durationMs)) return;
		} catch {
			// fall through to the switch trick
		}
	}
	try {
		const haptic = document.createElement('input');
		haptic.type = 'checkbox';
		haptic.setAttribute('switch', '');
		haptic.style.display = 'none';
		document.body.appendChild(haptic);
		haptic.click();
		haptic.remove();
	} catch {
		// no haptics available
	}
}
